import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { Link } from 'react-router-dom';

// Assets
import MajesticConcert from '../Assets/oSa.jpg';
import Logo from '../AllImages/GetItRight.png';
import BrushOne from '../Assets/BrushOne.png';
import BrushTwo from '../Assets/BrushTwo.png';
import BrushThree from '../Assets/BrushThree.png';
import BrushFour from '../Assets/BrushFour.png';

function BrushBackgrounds() {
  const brushes = [
    { src: BrushOne, style: { top: '5%', left: '5%', width: '120px', rotate: '-10deg' } },
    { src: BrushTwo, style: { top: '40%', right: '5%', width: '140px', rotate: '12deg' } },
    { src: BrushThree, style: { bottom: '20%', left: '10%', width: '100px', rotate: '-8deg' } },
    { src: BrushFour, style: { bottom: '10%', right: '20%', width: '130px', rotate: '15deg' } },
  ];
  return (
    <div className="absolute inset-0 z-0 pointer-events-none opacity-20">
      {brushes.map((b, i) => (
        <img key={i} src={b.src} alt="brush" className="absolute" style={{ ...b.style, transform: `rotate(${b.style.rotate})` }} />
      ))}
    </div>
  );
}

export default function SignInPage() {
  const navigate = useNavigate();
  const auth = getAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [resetMsg, setResetMsg] = useState('');

  // --- Submit ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResetMsg('');
    try {
      const { user } = await signInWithEmailAndPassword(auth, email, password);
      const name = user.displayName || user.email;

      let isAdmin = false;
      try {
        const staffSnap = await getDocs(query(collection(db, 'Staff'), where('primaryContact.email', '==', email)));
        isAdmin = !staffSnap.empty;
      } catch (permErr) {
        // If we don't have permission to read Staff, assume the user is not admin.
        console.warn('Staff lookup blocked by rules – treating as client', permErr);
      }

      requestAnimationFrame(() => {
        if (isAdmin) {
          navigate('/Admin', { state: { uid: user.uid, name } });
        } else {
          navigate('/DashBoard', { state: { uid: user.uid, name } });
        }
      });
    } catch (err) {
      setError(err.message);
    }
  };

  // --- Forgot password ---
  const handleForgotPassword = async () => {
    setError('');
    setResetMsg('');
    if (!email) {
      setError('Please enter your email first.');
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMsg(`A password reset link has been sent to ${email}.`);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-gray-100 to-gray-50 flex flex-col overflow-hidden">
      <BrushBackgrounds />
      {/* Back */}
      <div className="absolute top-4 left-4 z-20">
        <button onClick={() => navigate('/')} className="bg-red-600 text-white px-3 py-1 rounded-lg shadow hover:bg-red-500 transition">
          Regresar
        </button>
      </div>

      {/* Hero */}
      <div className="flex-grow relative">
        <img src={MajesticConcert} alt="Background" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/60" />

        <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6 }} className="relative z-10 flex flex-col items-center justify-center h-full px-4 py-16">
          <img src={Logo} alt="Logo" className="h-24 mb-4" />
          <h1 className="text-4xl font-serif font-bold text-red-600 mb-2">Iniciar Sesión</h1>
          <p className="text-gray-200 mb-8">Accede a tu cuenta</p>

          {/* Form card */}
          <div className="bg-white bg-opacity-90 backdrop-blur-md p-8 rounded-2xl shadow-2xl w-full max-w-sm">
            {error && <p className="text-red-600 mb-4 text-center">{error}</p>}
            {resetMsg && <p className="text-green-600 mb-4 text-center">{resetMsg}</p>}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-gray-700">Correo Electrónico</label>
                <input type="email" value={email} onChange={e=>setEmail(e.target.value)} className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-200" placeholder="you@example.com" required />
              </div>
              <div>
                <label className="block text-gray-700">Contraseña</label>
                <input type="password" value={password} onChange={e=>setPassword(e.target.value)} className="mt-1 w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-200" placeholder="********" required />
              </div>

              <div className="text-right">
                <button type="button" onClick={handleForgotPassword} className="text-red-600 hover:underline">
                  ¿Olvidaste tu contraseña?
                </button>
              </div>

              <button type="submit" className="w-full py-3 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-500 transition">
                Iniciar Sesión
              </button>
            </form>

            <p className="mt-4 text-center text-gray-700">
              ¿No tienes una cuenta?{' '}
              <Link to="/Onboard" className="text-red-600 hover:underline">Regístrate</Link>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}